const app = {
    state: {
        error: null,
        loading: false,
    },
    mutations: {
        'SET_LOADING'(state, loading) {
            state.loading = loading
        }
    },
    actions: {
        async load({ commit }, promise) {
            commit('SET_LOADING', true)
            let result = await promise
            commit('SET_LOADING', false)
      
            return result
        },
    }
}

export default app;


// WEBPACK FOOTER //
// ./src/store/app/index.js